import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchParams } from '../searchParams';

export enum StatusEnum {
    OPENED = 1,
    PENDING = 2,
    CLOSED = 3
}

@JsonObject('CaseSearchParams')
export class CaseSearchParams extends SearchParams {
    @JsonProperty('files', String, true)
    files: string | null = null;
    casesId = [];

    @JsonProperty('lawsuits', [Number], true)
    lawsuits = [];

    @JsonProperty('departments', [Number], true)
    departments = [];

    @JsonProperty('sequence', Number, true)
    fileSeq = undefined;

    @JsonProperty('case_number', Number, true)
    fileNum = undefined;

    @JsonProperty('clients', [Number], true)
    clients = [];

    @JsonProperty('is_approved', Boolean, true)
    isApproved = true;

    @JsonProperty('lawyers', [Number], true)
    lawyers = [];

    @JsonProperty('case_type', [Number], true)
    caseTypes = [];

    @JsonProperty('subject', String, true)
    subject: string | null = null;

    @JsonProperty('city', [Number], true)
    city: number[] = [];

    @JsonProperty('opponents', [Number], true)
    opponents = [];

    @JsonProperty('open_date_range_after', String, true)
    openDateAfter = null;

    @JsonProperty('open_date_range_before', String, true)
    openDateBefore = null;

    @JsonProperty('closed_date_range_after', String, true)
    closedDateAfter = null;

    @JsonProperty('closed_date_range_before', String, true)
    closedDateBefore = null;

    @JsonProperty('case_session_date_after', String, true)
    caseSessionDateFrom = null;

    @JsonProperty('case_session_date_before', String, true)
    caseSessionDateTo = null;

    @JsonProperty('departure_date_range_after', String, true)
    departureDateFrom = null;

    @JsonProperty('departure_date_range_before', String, true)
    departureDateTo = null;

    @JsonProperty('arrival_date_range_after', String, true)
    arrivalDateFrom = null;

    @JsonProperty('arrival_date_range_before', String, true)
    arrivalDateTo = null;

    @JsonProperty('ships', [Number], true)
    ships = [];

    @JsonProperty('owner_club', [Number], true)
    ownerClub = [];

    @JsonProperty('owner', [Number], true)
    owner = [];

    @JsonProperty('charter', [Number], true)
    charter = [];

    @JsonProperty('charter_club', [Number], true)
    charterClub = [];

    @JsonProperty('representatives', [Number], true)
    representatives = [];

    @JsonProperty('nm_lawyer', [Number], true)
    nmLawyer = [];

    @JsonProperty('crm_lawyer', [Number], true)
    crmLawyer = [];

    @JsonProperty('court', [Number], true)
    court = [];

    @JsonProperty('circle', [Number], true)
    circle = [];

    @JsonProperty('status', [Number], true)
    status: StatusEnum[] = [];

    @JsonProperty('policy_num', String, true)
    policyNum = null;

    @JsonProperty('container_num', String, true)
    containerNum = null;

    @JsonProperty('arrival_port', String, true)
    arrivalPort = null;

    @JsonProperty('departure_port', String, true)
    departurePort = null;

    @JsonProperty('charter_file_num', String, true)
    charterFileNum = null;

    @JsonProperty('charter_club_file_num', String, true)
    charterClubFileNum = null;

    @JsonProperty('owner_file_num', String, true)
    ownerFileNum = null;

    @JsonProperty('owner_club_file_num', String, true)
    ownerClubFileNum = null;
}
